<div class="maintenance-page">
  <a class="logo mb-3" routerLink="/home"><img src="assets/images/Med4All-logo.webp"/></a>
  <h1 class="maintenance-page__title">The platform is currently under maintenance</h1>
  <p class="maintenance-page__subtitle">Sorry for the inconvenience but we're performing some maintenance at the moment. You can always contact the CST if you have any questions. The platform will be back online shortly!</p>
</div>
